import React, { useState } from "react";
import {
  FaBars,
  FaCoins,
  FaDollarSign,
  FaGamepad,
  FaHome,
  FaHorse,
  FaStar,
  FaTimes,
  FaTools,
} from "react-icons/fa";
import NavDropdown from "./NavDropdown";
import NavItem from "./NavItem";
import NavButton from "./NavButton";
//@ts-ignore
import casino24 from "../../assets/logo-white.png";

const RouteSideNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Mobile Header */}
      <div className="bg-[#2c2e2f] text-white px-4 py-3 lg:hidden flex justify-between items-center">
        {/* <span className="text-lg font-bold">My App</span> */}
        <img alt="Casino24" src={casino24} className="w-[9rem]" />
        <button onClick={toggleNav} className="text-2xl">
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Side Navigation */}
      <div
        className={`fixed top-0 left-0 h-full bg-[#2c2e2f] text-white p-4 z-20 transform transition-transform duration-300 ease-in-out overflow-y-scroll ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 lg:static lg:flex-shrink-0 lg:w-64`}
      >
        <div className="flex flex-col h-full">
          <div className="flex-grow">
            <div className="w-full flex justify-center items-center pb-4">
              <img alt="Casino24" src={casino24} className="w-[9rem]" />
            </div>
            <nav>
              <NavButton
                title="MainPage"
                icon={<FaHome />}
                link="mainpage"
                toggle={toggleNav}
              />
              {/* Exclusice Deals */}
              <NavButton
                title="Exclusive Deals"
                icon={<FaStar />}
                link="exclusive-list"
                toggle={toggleNav}
              />
              {/* Online Casinos */}
              <NavDropdown
                title="Online Casino"
                icon={<FaCoins className="mr-2" />}
              >
                <NavItem
                  toggle={toggleNav}
                  title="Add New"
                  component={<div />}
                  link="add-edit-casino"
                />
                <NavItem
                  toggle={toggleNav}
                  title="Show List"
                  component={<div />}
                  link="casinos-list"
                />
                {/* <NavItem
                  toggle={toggleNav}
                  title="Categories"
                  component={<div />}
                  link="casino-categories"
                  disabled
                /> */}
              </NavDropdown>
              {/* Sports Betting */}
              <NavDropdown
                title="Sports Betting"
                icon={<FaHorse className="mr-2" />}
              >
                <NavItem
                  toggle={toggleNav}
                  title="Add New"
                  component={<div />}
                  link="add-edit-sport"
                />
                <NavItem
                  toggle={toggleNav}
                  title="Show List"
                  component={<div />}
                  link="sports-list"
                />
                {/* <NavItem
                  toggle={toggleNav}
                  title="Categories"
                  component={<div />}
                  link="sport-categories"
                  disabled
                /> */}
              </NavDropdown>
              {/* Games */}
              <NavDropdown title="Games" icon={<FaGamepad className="mr-2" />}>
                <NavItem
                  toggle={toggleNav}
                  title="Add New"
                  component={<div />}
                  link="add-edit-game"
                />
                <NavItem
                  toggle={toggleNav}
                  title="Show List"
                  component={<div />}
                  link="games-list"
                />
                {/* <NavItem
                  toggle={toggleNav}
                  title="Categories"
                  component={<div />}
                  link="game-categories"
                  disabled
                /> */}
              </NavDropdown>
              {/* Bonuses */}
              <NavDropdown
                title="Bonuses"
                icon={<FaDollarSign className="mr-2" />}
              >
                <NavItem
                  toggle={toggleNav}
                  title="Add New"
                  component={<div />}
                  link="add-edit-bonus"
                />
                <NavItem
                  toggle={toggleNav}
                  title="Show List"
                  component={<div />}
                  link="bonus-list"
                />
                {/* <NavItem
                  toggle={toggleNav}
                  title="Categories"
                  component={<div />}
                  link="bonus-categories"
                  disabled
                /> */}
              </NavDropdown>
              {/* Settings */}
              <NavButton
                title="Settings"
                icon={<FaTools />}
                link="settings"
                toggle={toggleNav}
              />
            </nav>
          </div>
        </div>
      </div>

      {/* Overlay for Mobile Navigation */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-10 lg:hidden"
          onClick={toggleNav}
        ></div>
      )}
    </>
  );
};

export default RouteSideNav;
